<div class="sticky top-0 z-[100] bg-neutral-06 shadow-header">
  <div class="max-w-screen-xl mx-auto z-10">
    <nav class="flex flex-nowrap items-center gap-6 bg-neutral-06">
      <a routerLink="{{ '/' + currentLanguage }}" class="flex items-center flex-shrink-0 text-neutral-06">
        <img class="p-4 md:p-0" src="assets/images/logo/AM-no-slogan.png" width="200" height="54" alt="logo" fetchpriority="high" />
      </a>

      <div class="min-w-0 flex-1">
        <div
          class="hidden md:flex relative z-[60] flex-wrap items-center justify-between bg-secondary-dark-green-2 h-12 rounded-bl-[30px] px-6
            xl:pr-0"
        >
          <div class="flex items-center text-neutral-06 shrink-0">
            <span class="font-medium text-sm whitespace-nowrap">(+84 28) 38 237 791</span>
          </div>

          <div class="flex flex-wrap items-center gap-3 text-neutral-06 text-xs z-10">
            <!-- fDragon -->
            <a
              (click)="openfDragon()"
              class="cursor-pointer whitespace-nowrap rounded-full bg-neutral-06 font-bold px-3 py-1 transition-opacity
                hover:bg-neutral-06/90"
            >
              <img class="p-4 md:p-0" src="assets/images/logo/fDragon-logo.png" alt="fDragon-logo" />
            </a>

            <!-- Mở tài khoản -->
            <a
              routerLink="{{ '/' + currentLanguage + '/mo-tai-khoan' }}"
              class="cursor-pointer whitespace-nowrap rounded-3xl bg-secondary text-neutral-06 text-sm font-semibold px-3 py-1.5
                transition-opacity hover:bg-secondary/90"
            >
              {{ 'OPEN_ACCOUNT' | translate }}
            </a>

            <!-- Language dropdown (flag + chevron), opens on hover like the other nav dropdowns -->
            <div class="group relative">
              <button
                type="button"
                class="flex items-center justify-center gap-1 rounded-full bg-[#71B949] px-3.5 py-1.5 cursor-pointer transition-colors
                  hover:bg-[#7bc653]"
                aria-haspopup="listbox"
              >
                <img *ngIf="currentLanguage === 'vi'" src="assets/svg/ic-vn.svg" alt="ic-vn" width="22" height="14" />
                <img *ngIf="currentLanguage === 'en'" src="assets/svg/ic-en.svg" alt="ic-us" width="22" height="14" />
                <img src="assets/svg/ic-arrow-down-list.svg" alt="ic-arrow-down" />
              </button>
              <div class="group-hover:block w-[72px] dropdown-menu absolute hidden right-0 top-full z-100 pt-1">
                <ul class="rounded-md p-1 bg-neutral-06 overflow-hidden shadow-dropdown-menu">
                  <li>
                    <a
                      class="p-1 mb-1 rounded-md flex justify-center cursor-pointer hover:bg-neutral-08"
                      [class.bg-neutral-08]="currentLanguage === 'vi'"
                      (click)="changeSiteLanguage('vi')"
                    >
                      <img src="assets/svg/ic-vn.svg" alt="ic-vn" width="26" height="18" />
                    </a>
                  </li>
                  <li>
                    <a
                      class="p-1 mb-1 rounded-md flex justify-center cursor-pointer hover:bg-neutral-08"
                      [class.bg-neutral-08]="currentLanguage === 'en'"
                      (click)="changeSiteLanguage('en')"
                    >
                      <img src="assets/svg/ic-en.svg" alt="ic-en" width="26" height="18" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            <!-- Search block: fixed width container avoids the icon / input swap shifting layout -->
            <div class="relative z-20 flex items-center justify-end w-9">
              <ng-container *ngIf="isShowSearch || searchTxt; else searchIcon">
                <div class="flex absolute inset-y-0 right-2 z-30 items-center pl-3 pointer-events-none">
                  <img src="assets/svg/ic-search-gray.svg" alt="ic-search" width="20" height="20" />
                </div>
                <input
                  #search
                  (blur)="isShowSearch = false"
                  (keyup.enter)="enterSearch(search.value)"
                  type="text"
                  [value]="searchTxt"
                  class="absolute right-0 z-20 block w-56 h-8 px-2 pr-8 text-xs text-neutral-02 bg-neutral-06 border border-neutral-02
                    rounded-md shadow-sm focus:border-primary focus:ring-1 focus:ring-primary placeholder:text-neutral-18
                    placeholder:opacity-60"
                  placeholder="{{ 'SEARCH_HEADER_PLACEHOLDER' | translate }}"
                />
              </ng-container>
              <ng-template #searchIcon>
                <button
                  type="button"
                  (click)="openSearch()"
                  [attr.aria-label]="'SEARCH' | translate"
                  class="flex items-center justify-end cursor-pointer"
                >
                  <img src="assets/svg/ic-search.svg" alt="ic-search" width="20" height="20" />
                </button>
              </ng-template>
            </div>
          </div>
        </div>

        <div class="relative z-50 hidden md:block w-full min-h-[42px]" id="mobile-menu">
          <ul
            class="flex flex-col w-full justify-around py-1 mt-4 bg-gray-50 text-sm rounded-lg border border-gray-100 md:flex-row
              md:flex-wrap md:space-x-4 md:mt-0 md:text-sm md:font-medium md:border-0 md:bg-neutral-06"
          >
            <!-- AboutUs -->
            <li class="group relative" *ngIf="navAboutUs && navAboutUs.children && navAboutUs.children[0]">
              <button
                data-dropdown-toggle="dropdownNavbar"
                routerLinkActive="active-router"
                disabled
                routerLink="{{ '/' + currentLanguage + '/' + navAboutUs.item.linkUrl }}"
                class="flex justify-between items-center py-2 px-3 w-full text-sm font-bold text-neutral-01 rounded-lg custom-btn-header
                  cursor-pointer hover:text-primary hover:bg-secondary-light-green-3"
              >
                {{ navAboutUs.item.name || 'Về QLQ Rồng Việt' }}
                <img src="assets/svg/ic-down-arrow.svg" alt="ic-down-arrow" width="20" height="20" />
              </button>

              <!-- Dropdown menu -->
              <div
                *ngIf="navAboutUs.children"
                class="group-hover:block hidden dropdown-menu absolute h-auto p-2 left-1/2 -translate-x-1/2 overflow-hidden"
              >
                <ul class="w-72 bg-neutral-06 text-sm mt-[-4px] rounded-lg overflow-hidden relative z-[60] shadow-dropdown-menu">
                  <ng-template ngFor let-item [ngForOf]="navAboutUs.children" [ngForTrackBy]="trackByLinkUrl">
                    <li
                      *ngIf="item.item.showMenu"
                      class="flex justify-between menu-item text-neutral-01 hover:bg-secondary-light-green-3 hover:text-primary
                        hover:font-bold font-medium"
                    >
                      <a
                        class="w-full px-2.5 py-3 cursor-pointer"
                        routerLinkActive="active-router"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="{{ '/' + currentLanguage + '/' + navAboutUs.item.linkUrl + '/' + item.item.linkUrl }}"
                        >{{ item.item.name }}</a
                      >
                    </li>
                  </ng-template>
                </ul>
              </div>
            </li>

            <!-- Investment Funds  -->
            <li class="group relative" *ngIf="investmentFundsNav && investmentFundsNav.children && investmentFundsNav.children[0]">
              <button
                data-dropdown-toggle="dropdownNavbar"
                routerLinkActive="active-router"
                disabled
                routerLink="{{ '/' + currentLanguage + '/' + investmentFundsNav.item.linkUrl }}"
                class="flex justify-between items-center py-2 px-3 w-full text-sm font-bold text-neutral-01 rounded-lg custom-btn-header
                  cursor-pointer hover:text-primary hover:bg-secondary-light-green-3"
              >
                {{ investmentFundsNav.item.name || 'Quản lý quỹ đầu tư' }}
                <img src="assets/svg/ic-down-arrow.svg" alt="ic-down-arrow" width="20" height="20" />
              </button>

              <!-- Dropdown menu -->
              <div
                *ngIf="investmentFundsNav.children"
                class="group-hover:block hidden dropdown-menu absolute h-auto p-2 left-1/2 -translate-x-1/2 overflow-hidden"
              >
                <ul class="w-72 bg-neutral-06 text-sm mt-[-4px] rounded-lg overflow-hidden relative z-[60] shadow-dropdown-menu">
                  <ng-template ngFor let-item [ngForOf]="investmentFundsNav.children" [ngForTrackBy]="trackByLinkUrl">
                    <li
                      *ngIf="item.item.status && item.item.showMenu"
                      class="flex justify-between menu-item text-neutral-01 hover:bg-secondary-light-green-3 hover:text-primary
                        hover:font-bold font-medium"
                    >
                      <a
                        class="w-full px-2.5 py-3 cursor-pointer"
                        routerLinkActive="active-router"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="{{ '/' + currentLanguage + '/' + investmentFundsNav.item.linkUrl + '/' + item.item.linkUrl }}"
                        >{{ item.item.name }}</a
                      >
                    </li>
                  </ng-template>
                </ul>
              </div>
            </li>

            <li *ngIf="portfolioNav" class="group relative">
              <a
                data-dropdown-toggle="dropdownNavbar"
                routerLink="{{ '/' + currentLanguage + '/' + portfolioNav.linkUrl }}"
                routerLinkActive="active-router"
                class="flex justify-between items-center py-2 px-3 w-full text-sm font-bold text-neutral-01 rounded-lg custom-btn-header
                  cursor-pointer hover:text-primary hover:bg-secondary-light-green-3"
              >
                {{ portfolioNav.name || 'Quản lý danh mục đầu tư' }}
              </a>
            </li>

            <li *ngIf="advisoryNav" class="group relative">
              <a
                routerLink="{{ '/' + currentLanguage + '/' + advisoryNav.linkUrl }}"
                routerLinkActive="active-router"
                class="flex justify-between items-center py-2 px-3 w-full text-sm font-bold text-neutral-01 rounded-lg custom-btn-header
                  cursor-pointer hover:text-primary hover:bg-secondary-light-green-3"
              >
                {{ advisoryNav.name || 'Tư vấn đầu tư' }}
              </a>
            </li>

            <li *ngIf="iDAtHomePage" class="group relative">
              <button
                data-dropdown-toggle="dropdownNavbar"
                routerLinkActive="active-router"
                disabled
                class="flex justify-between items-center py-2 px-3 w-full text-sm font-bold text-neutral-01 rounded-lg custom-btn-header
                  cursor-pointer hover:text-primary hover:bg-secondary-light-green-3"
              >
                {{ 'INFORMATION_DISCLOSURE' | translate }}
                <img src="assets/svg/ic-down-arrow.svg" alt="ic-down-arrow" width="20" height="20" />
              </button>

              <!-- Dropdown menu -->
              <div
                *ngIf="iDAtHomePage"
                class="group-hover:block hidden dropdown-menu absolute h-auto p-2 left-1/2 -translate-x-1/2 overflow-hidden"
              >
                <ul class="w-72 bg-neutral-06 text-sm mt-[-4px] rounded-lg overflow-hidden relative z-[60] shadow-dropdown-menu">
                  <ng-template ngFor let-item [ngForOf]="iDAtHomePage" [ngForTrackBy]="trackByHomePageItem">
                    <li
                      *ngIf="checkQuanHeCoDongAboutUs(item)"
                      class="flex justify-between menu-item text-neutral-01 hover:bg-secondary-light-green-3 hover:text-primary
                        hover:font-bold font-medium"
                    >
                      <a
                        class="w-full px-2.5 py-3 cursor-pointer"
                        routerLinkActive="active-router"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="{{
                          '/' +
                            currentLanguage +
                            '/' +
                            navAboutUs?.item?.linkUrl +
                            '/' +
                            shareholderRelationsNav?.linkUrl +
                            '/' +
                            catInformationDisclosure?.linkUrl
                        }}"
                      >
                        {{ currentLanguage === 'vi' ? item.name : item?.nameEn }}
                      </a>
                    </li>
                    <li
                      *ngIf="!checkQuanHeCoDongAboutUs(item) && checkShowOnMenu(item)"
                      class="flex justify-between menu-item text-neutral-01 hover:bg-secondary-light-green-3 hover:text-primary
                        hover:font-bold font-medium"
                    >
                      <a
                        class="w-full px-2.5 py-3 cursor-pointer"
                        routerLink="{{ '/' + currentLanguage + '/' + investmentFundsNav?.item?.linkUrl + '/' + item.linkUrl }}"
                        routerLinkActive="active-router"
                        [routerLinkActiveOptions]="{ exact: true }"
                        [queryParams]="{ tab: 'disclosure' }"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ng-template>
                </ul>
              </div>
            </li>

            <li class="group relative" *ngIf="knowledgeNav && knowledgeNav.children">
              <button
                data-dropdown-toggle="dropdownNavbar"
                routerLinkActive="active-router"
                disabled
                routerLink="{{ '/' + currentLanguage + '/' + knowledgeNav.item.linkUrl }}"
                class="flex justify-between items-center py-2 px-3 w-full text-sm font-bold text-neutral-01 rounded-lg custom-btn-header
                  cursor-pointer hover:text-primary hover:bg-secondary-light-green-3"
              >
                {{ knowledgeNav.item.name || 'Kiến thức đầu tư' }}
                <img src="assets/svg/ic-down-arrow.svg" alt="ic-down-arrow" width="20" height="20" />
              </button>

              <!-- Dropdown menu -->
              <div
                *ngIf="knowledgeNav.children"
                class="group-hover:block hidden dropdown-menu absolute h-auto p-2 left-1/2 -translate-x-1/2 overflow-hidden"
              >
                <ul class="w-72 bg-neutral-06 text-sm mt-[-4px] rounded-lg overflow-hidden relative z-[60] shadow-dropdown-menu">
                  <ng-template ngFor let-item [ngForOf]="knowledgeNav.children" [ngForTrackBy]="trackByLinkUrl">
                    <li
                      *ngIf="item.item.showMenu"
                      class="flex justify-between menu-item text-neutral-01 hover:bg-secondary-light-green-3 hover:text-primary
                        hover:font-bold font-medium"
                    >
                      <a
                        class="w-full px-2.5 py-3 cursor-pointer"
                        routerLinkActive="active-router"
                        [routerLinkActiveOptions]="{ exact: true }"
                        routerLink="{{ '/' + currentLanguage + '/' + knowledgeNav.item.linkUrl + '/' + item.item.linkUrl }}"
                        >{{ item.item.name }}</a
                      >
                    </li>
                  </ng-template>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="flex items-center pr-4 gap-4 md:hidden">
        <button
          type="button"
          class="flex cursor-pointer items-center justify-center"
          (click)="openSeachMobile()"
          [attr.aria-label]="'SEARCH' | translate"
        >
          <img src="assets/svg/ic-search-green.svg" alt="ic-search" width="24" height="24" />
        </button>
        <button
          type="button"
          class="flex cursor-pointer items-center justify-center"
          (click)="toggleMenu()"
          [attr.aria-label]="isOpenMenu ? 'Close menu' : 'Open menu'"
        >
          <img *ngIf="!isOpenMenu" src="assets/svg/ic-menu.svg" alt="ic-menu" width="24" height="24" />
          <img *ngIf="isOpenMenu" src="assets/svg/ic-close-green.svg" alt="ic-close-green" width="24" height="24" />
        </button>
      </div>
    </nav>
  </div>
  <div class="hidden h-12 absolute bg-secondary-dark-green-2 w-1/2 right-0 top-0 xl:block"></div>
</div>

<app-drawer [isOpenMenu]="isOpenMenu" (isCloseMenu)="close($event)"></app-drawer>

<!-- search mobile -->
<div class="pt-12 px-5 md:hidden" *ngIf="isShowSearchMobile">
  <p class="text-4xl text-primary font-bold">{{ 'SEARCH' | translate }}</p>

  <svg class="my-8" width="55" height="6" viewBox="0 0 55 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.93359 3H51.9336" stroke="#C4C4C4" stroke-width="6" stroke-linecap="round" />
  </svg>

  <input
    #mobileSearch
    type="text"
    [(ngModel)]="searchTxt"
    (keyup.enter)="enterSearch(mobileSearch.value)"
    class="block w-full pl-0 text-xs text-neutral-18 h-5 border-l-0 border-r-0 border-t-0 border-b shadow-none focus:border-neutral-01
      border-neutral-01 placeholder:text-neutral-18 placeholder:opacity-40"
    placeholder="{{ 'SEARCH_HEADER_PLACEHOLDER' | translate }}"
  />

  <div class="flex justify-center">
    <button
      class="mt-8 mb-[60px] bg-primary text-sm font-medium text-neutral-06 flex py-3 px-10 items-center"
      (click)="enterSearch(searchTxt)"
    >
      {{ 'SEARCH' | translate }}
      <img class="ml-2" src="assets/svg/ic-search.svg" alt="ic-search" width="20" height="20" />
    </button>
  </div>
</div>
<!-- search mobile -->
